"use client";

import * as React from "react";
import { cn } from "@/utils";

export function BorderContainer({
  children,
  className,
  note,
}: {
  children: React.ReactNode;
  className?: string;
  note?: React.ReactNode;
}) {
  return (
    <section className={cn("mb-16 space-y-6", className)}>
      {children}
      {note ? (
        <p className="max-w-3xl text-sm leading-relaxed text-muted/90">{note}</p>
      ) : null}
    </section>
  );
}

export default BorderContainer;
